<template>
  <div class="rtc  playback-options">
    <div class="option-group">
      <select v-model="selected" class="item" @change="onSelect">
        <option v-for="option in options" :value="option.value" :key="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="option-group">
      <div>
        <a ref="webrtc_link">WebRTC <i ref="webrtc_icon"></i></a>
      </div>
      <div>
        <a ref="sw_link">ServiceWorker <i ref="sw_icon"></i></a>
      </div>
      <div>
        <a ref="mse_link">MSE <i ref="mse_icon"></i></a>
      </div>
    </div>

    <div class="blank"></div>
  </div>
</template>

<script>
import {getQueryParam, isMSESupported, isWebRTCSupported} from '@/utils/tools'

export default {
  name: 'WebRTC',
  data() {
    return {
      selected: '',
      options: [
        { value: 'videojs', text: 'video.js' },
        { value: 'hlsjs', text: 'hls.js' },
        { value: 'shaka', text: 'shaka' },
        { value: 'bitmovin', text: 'bitmovin' },
        { value: 'dashjs', text: 'dash.js' },
        { value: 'rx', text: 'rx-player' },
        { value: 'mp4', text: 'MP4' },
      ]
    };
  },
  mounted() {
    this.selected = getQueryParam('player') || 'videojs';
    if(isWebRTCSupported()) {
      this.$refs.webrtc_icon.className = 'fa fa-check'
      this.$refs.webrtc_link.style.color = 'green'
    } else {
      this.$refs.webrtc_icon.className = 'fa fa-close'
      this.$refs.webrtc_link.style.color = 'red'
    }

    if('serviceWorker' in navigator) {
      this.$refs.sw_icon.className = 'fa fa-check'
      this.$refs.sw_link.style.color = 'green'
    } else {
      this.$refs.sw_icon.className = 'fa fa-close'
      this.$refs.sw_link.style.color = 'red'
    }

    if(isMSESupported()) {
        this.$refs.mse_icon.className = 'fa fa-check'
        this.$refs.mse_link.style.color = 'green'
    } else {
        this.$refs.mse_icon.className = 'fa fa-close'
        this.$refs.mse_link.style.color = 'red'
    }
  },
  methods: {
    onSelect() {
      this.$parent.onPlayerSelected(this.selected);
    }
  }
}
</script>

<style scoped>
  .rtc {
    margin-top: 10px;
    border-bottom: 1px solid #000;
    border-bottom: 1px solid green;
  }
  .blank {
    clear: both;
  }
  a {
    font-size: 0.9rem;
    font-weight: 550;
    padding: 6px 2px;
  }
  .playback-options {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-around;

  }

  .option-group {
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.5em;
  }

  .option-group .item {
    margin-right: 0.3em;
    display: block;
    width: 100%;
    height: calc(2.25em + 2px);
    padding: 0.175rem 0.15rem;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.0em;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25em;
    box-sizing: border-box;
  }
</style>
